var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhoneIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "1rem",
    viewBox: "0 0 17 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "phone-outline",
    d: "M19.056,14.806a10.275,10.275,0,0,1-3.4-.567h-.283a.857.857,0,0,0-.661.283L12.633,16.6A14.7,14.7,0,0,1,6.4,10.367L8.478,8.289a.752.752,0,0,0,.189-.944,13.429,13.429,0,0,1-.472-3.4A1.016,1.016,0,0,0,7.25,3H3.944A1.016,1.016,0,0,0,3,3.944,16.042,16.042,0,0,0,19.056,20,1.016,1.016,0,0,0,20,19.056V15.75a1.016,1.016,0,0,0-.944-.944M4.889,4.889H6.306a18.859,18.859,0,0,0,.472,2.456L5.644,8.478a15.166,15.166,0,0,1-.756-3.589M18.111,18.111a15.166,15.166,0,0,1-3.589-.756l1.133-1.133a10.267,10.267,0,0,0,2.456.378Z",
    transform: "translate(-3 -3)",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneIcon);
export default __webpack_public_path__ + "static/media/phone-icon.81b4450823bf1591d2458751457f3b98.svg";
export { ForwardRef as ReactComponent };